(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["astra-draft-product"]) return;
  try {
    
const initAstraDraft = root => {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const panels = [...root.querySelectorAll('[data-concept-panel]')];
  const buttons = [...root.querySelectorAll('[data-concept-button]')];
  const selectConcept = index => {
    panels.forEach(panel => { panel.hidden = panel.dataset.conceptPanel !== String(index); });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.conceptButton === String(index))));
    root.querySelector('[data-gallery-status]').textContent = buttons.find(button => button.dataset.conceptButton === String(index))?.querySelector('span:last-child')?.textContent.trim() || '';
  };
  buttons.forEach(button => button.addEventListener('click', () => selectConcept(button.dataset.conceptButton)));
  root.querySelectorAll('[data-variant-choice]').forEach(input => input.addEventListener('change', () => {
    if (!input.checked) return;
    const price = root.querySelector('[data-variant-price]');
    if (price) price.textContent = input.dataset.price;
    const scent = root.querySelector('[data-current-scent]');
    if (scent) scent.textContent = input.dataset.scent;
    const barcode = root.querySelector('[data-variant-barcode]');
    if (barcode) barcode.textContent = input.dataset.barcode || '—';
    const template = root.querySelector(`template[data-variant-hero="${input.value}"]`);
    const heroPanel = panels[0];
    if (root.dataset.mediaReady === 'true') {
      const opener = heroPanel.querySelector('[data-open-image]');
      const placeholder = heroPanel.querySelector('[data-hero-placeholder]');
      if (template && opener) {
        opener.hidden = false;
        if (placeholder) placeholder.hidden = true;
        opener.replaceChildren(template.content.cloneNode(true));
        const sourceImage = opener.querySelector('img');
        const thumb = buttons[0].querySelector('img');
        if (sourceImage && thumb) {
          thumb.src = sourceImage.src;
          thumb.srcset = sourceImage.srcset;
        }
      } else {
        heroPanel.querySelectorAll('[data-open-image]').forEach(item => { item.hidden = true; });
        if (placeholder) placeholder.hidden = false;
      }
    }
    const factsTemplate = root.querySelector(`template[data-variant-facts="${input.value}"]`);
    const factsRegion = root.querySelector('[data-variant-drug-facts]');
    if (factsTemplate && factsRegion) factsRegion.replaceChildren(factsTemplate.content.cloneNode(true));
    const isFree = input.dataset.scent.toLowerCase() === 'fragrance free';
    root.querySelectorAll('[data-fragrance-free-content]').forEach(content => {
      content.hidden = !isFree;
      const scented = content.parentElement.querySelector('[data-scented-content]');
      if (scented) scented.hidden = isFree;
    });
    const url = new URL(window.location.href);
    url.searchParams.set('variant', input.value);
    history.replaceState({}, '', url);
    selectConcept(0);
    root.querySelector('.astra-draft__thumbnails').scrollLeft = 0;
  }));
  const dialog = root.querySelector('dialog');
  root.addEventListener('click', event => {
    const opener = event.target.closest('[data-open-image]');
    if (opener && dialog) {
      const image = opener.querySelector('img');
      if (image) {
        const zoomImage = image.cloneNode(true);
        zoomImage.removeAttribute('srcset');
        zoomImage.removeAttribute('sizes');
        zoomImage.loading = 'eager';
        dialog.querySelector('[data-lightbox-image]').replaceChildren(zoomImage);
        dialog.showModal();
      }
    }
    if (event.target.closest('[data-close-image]') && dialog) dialog.close();
  });
};
document.querySelectorAll('[data-astra-draft]').forEach(initAstraDraft);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-astra-draft]').forEach(initAstraDraft));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["astra-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('astra-marquee')) {
  customElements.define('astra-marquee', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button || button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-label', paused ? button.dataset.resume : button.dataset.pause);
        button.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["astra-store-finder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('astra-store-finder'))customElements.define('astra-store-finder',class extends HTMLElement{connectedCallback(){const load=()=>{if(!document.querySelector('script[src="https://stockist.co/embed/v1/widget.min.js"]')){const script=document.createElement('script');script.src='https://stockist.co/embed/v1/widget.min.js';script.async=true;document.head.append(script)}};if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){load();this.observer.disconnect()}},{rootMargin:'500px'});this.observer.observe(this)}else load()}disconnectedCallback(){this.observer?.disconnect()}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["astra-worlds"] && !Shopify.designMode) return;
  try {
    
function initAstraWorlds(root=document){
  root.querySelectorAll('[data-astra-worlds]').forEach(section=>{
    if(section.dataset.worldsReady)return;
    section.dataset.worldsReady='true';
    const list=section.querySelector('[role="tablist"]');
    const tabs=[...list.querySelectorAll('[role="tab"]')];
    const panels=[...section.querySelectorAll('[data-world-panel]')];
    if(section.hasAttribute('data-astra-defer-art')){
      const hero=panels.find(panel=>panel.dataset.worldPanel===section.dataset.defaultWorld)?.querySelector('.astra-worlds__photograph img');
      const showArt=()=>{section.dataset.astraHeroReady='true'};
      if(!hero||hero.complete)showArt();
      else{
        hero.addEventListener('load',showArt,{once:true});
        hero.addEventListener('error',showArt,{once:true});
      }
    }
    const select=(tab,focus=false)=>{
      tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1});
      panels.forEach(panel=>{panel.hidden=panel.dataset.worldPanel!==tab.dataset.world;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',`WorldTab-${section.querySelector('h1').id.replace('AstraWorlds-','')}-${panel.dataset.worldPanel}`)});
      if(focus)tab.focus();
    };
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>select(tab));
      tab.addEventListener('keydown',event=>{
        let next;
        if(event.key==='ArrowRight'||event.key==='ArrowDown')next=(index+1)%tabs.length;
        if(event.key==='ArrowLeft'||event.key==='ArrowUp')next=(index+tabs.length-1)%tabs.length;
        if(event.key==='Home')next=0;
        if(event.key==='End')next=tabs.length-1;
        if(next!==undefined){event.preventDefault();select(tabs[next],true)}
      });
    });
    select(tabs.find(t=>t.dataset.world===section.dataset.defaultWorld)||tabs[0]);
    list.hidden=false;
  });
}
initAstraWorlds();
document.addEventListener('shopify:section:load',()=>initAstraWorlds());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});


  } catch(e) { console.error(e); }
})();
})();
